// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "li a[data-v-a727f8b8],li a.tabmenu[data-v-a727f8b8]{cursor:pointer}li a.tabmenu[data-v-a727f8b8]{border-radius:50px;background:#fff;color:#395674;opacity:1}li a.tabmenu[data-v-a727f8b8]:hover{background:#e5faff!important}li a.tabmenu.active[data-v-a727f8b8]{color:#fff;background-color:#309db6;opacity:1}li a.tabmenu.active[data-v-a727f8b8]:hover{background:#309db6!important;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
